import api from '../../../services/api';

const API_URL = '/api/v1/admin/dataview';
/**
 * @returns {Promise<ApiAdmin.GetAllSetupDataviews>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getAllDataview = () => api.get(API_URL);
